import CryptoJS from "crypto-js"

const SECRET_KEY = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_ENCODE_KEY)
const IV = CryptoJS.enc.Utf8.parse("0123456789abcdef") // must be 16 bytes

export function encryptData(data: any): string {
  const plaintext = typeof data === "string" ? data : JSON.stringify(data)
  const encrypted = CryptoJS.AES.encrypt(plaintext, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

export function decryptData(ciphertext: string): any {
  const decrypted = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  const plaintext = decrypted.toString(CryptoJS.enc.Utf8)
  try {
    return JSON.parse(plaintext)
  } catch {
    return plaintext
  }
}
